import { useQuery } from "@tanstack/react-query";
import {
  useAuditLog,
  useAuditLogActions,
  useAuditLogEntityTypes,
} from "@/hooks/queries/useAuditLog";
import type { AuditLogFilters } from "@/lib/audit-log.api";
import { usersApi } from "@/lib/users.api";

export function useAuditLogPageData(filters: AuditLogFilters) {
  const { data, isLoading, isFetching } = useAuditLog(filters);
  const { data: actions = [] } = useAuditLogActions();
  const { data: entityTypes = [] } = useAuditLogEntityTypes();
  const { data: userOptions = [] } = useQuery({
    queryKey: ["users", "audit-log-lookup"],
    queryFn: () => usersApi.list({ pageSize: 200 }).then((response) => response.data.data),
  });

  return {
    rows: data?.data ?? [],
    total: data?.total ?? 0,
    actions,
    entityTypes,
    userOptions,
    isLoading,
    isFetching,
  };
}
